<template>
	<div class="container" id="BioTestingQuizDashboard">
		<div class="row text-center">
			<h4 class="col gold">
				<span v-text="this.$route.meta.title"></span>
			</h4>
		</div>

		<div class="row">
			<div class="col text-left">
				<BioTestingButtons title='<i class="fas fa-home"></i> Admin Quiz Actions' />
			</div>
		</div>

		<div class="row" id="">
			<div class="col-md-6 my-1">
				<b-form-group class="mb-0">
					<b-input-group size="sm">
						<b-form-input
							id="filter-input"
							v-model="filter"
							type="search"
							placeholder="Search Members"
						></b-form-input>

						<b-input-group-append>
							<b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
						</b-input-group-append>
					</b-input-group>
				</b-form-group>
			</div>

			<div class="col-md-3 col-5 my-1">
				<b-form-group class="mb-0">
					<b-form-select
						id="per-page-select"
						v-model="perPage"
						:options="pageOptions"
						size="sm"
					></b-form-select>
				</b-form-group>
			</div>

			<div class="col-md-3 col-7 my-1">
				<b-pagination
					v-model="currentPage"
					:total-rows="totalRows"
					:per-page="perPage"
					align="right"
					size="sm"
					class="my-0"
				></b-pagination>
			</div>
		</div>

		<div class="row">
			<div class="col">
				<b-table
					responsive="md"
					:items="user_quizzes"
					:busy="isBusy"
					:fields="table_fields"
					:filter="filter"
					:filter-included-fields="filterOn"
					@filtered="onFiltered"
					:current-page="currentPage"
					:per-page="perPage"
					:sort-by.sync="sortBy"
					:sort-desc.sync="sortDesc"
					sort-icon-left
					class="small"
					show-empty
					primary-key="pkid"
				>
					<template #table-busy>
						<div class="text-center text-danger my-2">
							<b-spinner class="align-middle"></b-spinner><br />
							<strong>Loading...</strong>
						</div>
					</template>

					<template v-slot:cell(actions)="data">
						<b-dropdown
							size="sm"
							class=""
							:variant="data.item._rowVariant"
							toggle-class="text-decoration-none"
							no-caret
						>
							<template #button-content>
								<span v-if="data.item.status == 0" class="">
									<i class="fas fa-trash"></i>
								</span>
								<span v-else-if="data.item.status == 1" class="">
									<i class="fas fa-check"></i>
								</span>
								<span v-else-if="data.item.status == 2" class="">
									<i class="fas fa-arrow-right"></i>
								</span>
								<span v-else-if="data.item.status == 9" class="">
									<i class="fas fa-clock"></i>
								</span>
							</template>

							<b-dropdown-item>
								<router-link :to="'/bioTesting/quiz_result/' + data.item.pkid" class="gold">
									<b-button variant="outline-primary">
										View <span v-text="data.item.first_name"></span>'s results
									</b-button>
								</router-link>
							</b-dropdown-item>

							<b-dropdown-item>
								<b>Set Status</b><br />
								<b-button-group size="sm">
									<b-button
										variant="outline-success"
										@click="setQuizResultStatus(data.item, 2)"
									>
										<i class="fas fa-arrow-right"></i> Submitted
									</b-button>

									<b-button
										variant="outline-warning"
										@click="setQuizResultStatus(data.item, 9)"
									>
										<i class="fas fa-clock"></i> In-Progress
									</b-button>
									<b-button
										variant="outline-secondary"
										@click="setQuizResultStatus(data.item, 1)"
									>
										<i class="fas fa-check"></i> Completed
									</b-button>
									<b-button
										variant="outline-danger"
										@click="
											confirmDelete(
												'Are you sure you want to completly remove this quiz results?',
												data.item
											)
										"
									>
										<i class="fas fa-times"></i> Delete
									</b-button>
								</b-button-group>
							</b-dropdown-item>
						</b-dropdown>
					</template>

					<template v-slot:cell(status)="data">
						<span v-text="arrayElmGet(options.statuses, data.item)" class="pl-1"></span>
					</template>
				</b-table>
			</div>
		</div>
	</div>
</template>

<script>
import axios from 'axios';
import BioTestingButtons from '../components/BioTestingButtons.vue';

export default {
	name: 'BioTestingQuizDashboard',
	components: {
		BioTestingButtons,
	},
	props: {},
	data() {
		return {
			table_fields: [
				{ key: 'actions', label: 'Actions' },
				{ key: 'status', label: 'Status', sortable: true, sortDirection: 'asc' },
				{ key: 'created', label: 'Date', sortable: true, sortDirection: 'desc' },
				{ key: 'first_name', label: 'First name', sortable: true, sortDirection: 'asc' },
				{ key: 'last_name', label: 'Last name', sortable: true, sortDirection: 'asc' },
				{ key: 'quiz_title', label: 'Quiz', sortable: true, sortDirection: 'asc' },
				{ key: 'pkid', label: 'ID' },
			],
			user_quizzes: [],

			options: {
				statuses: [
					{ value: 0, text: 'Deleted' },
					{ value: 1, text: 'Complete' },
					{ value: 2, text: 'Submitted' },
					{ value: 9, text: 'In-Progress' },
				],
			},

			isBusy: true,
			sortBy: '_order',
			sortDirection: 'asc',
			sortDesc: false,
			totalRows: 0,
			currentPage: 1,
			perPage: 50,
			pageOptions: [
				{ value: 50, text: 'Num to Show' },
				25,
				50,
				100,
				{ value: 500, text: 'All' },
			],
			filter: null,
			filterOn: [],
		};
	},
	methods: {
		arrayElmGet(obj, value) {
			const entries = Object.entries(obj);
			for (const v of entries) {
				if (parseInt(v[1].value) === parseInt(value.status)) {
					return v[1].text;
				}
			}
			return null;
		},

		confirmDelete(message, item) {
			console.log('confirmDelete:' + item.pkid);
			this.$bvModal
				.msgBoxConfirm(message, {
					title: 'Confirm delete',
					size: 'sm',
					buttonSize: 'sm',
					okVariant: 'danger',
					okTitle: 'Yes - delete',
					cancelTitle: 'Cancel',
					footerClass: 'p-2',
					hideHeaderClose: false,
					centered: true,
				})
				.then((value) => {
					if (value == true) {
						this.setQuizResultStatus(item, 0);
					}
				})
				.catch((err) => {
					console.log('confirmDelete:' + err);
				});
		},

		notificationsGet() {
			var _this = this;

			let params = new URLSearchParams();
			params.append('token', _this.$store.state.session_id);

			axios({
				url: _this.$store.state.api_url + 'notificationsGet',
				params: params,
			})
				.then(function (response) {
					if (response.data !== null) {
						_this.$store.commit('notificationsSet', response.data.store_notifications);
					}
				})
				.catch((err) => {
					console.log('confirmDelete:' + err);
				});
		},

		onFiltered(filteredItems) {
			this.totalRows = filteredItems.length;
			this.currentPage = 1;
		},

		setQuizResultStatus(item, status) {
			let _this = this;
			let params = new URLSearchParams();
			params.append('token', _this.$store.state.session_id);
			params.append('status', status);
			params.append('pkid', item.pkid);
			params.append('questionnaire_id', item.quiz_id);

			axios({
				url: _this.$store.state.api_url + 'bio_questionnaire_result_set_status',
				params: params,
			})
				.then(function (response) {
					item.status = response.data.status;
					item._rowVariant = response.data._rowVariant;
					item._order = response.data._order;
					if (item.status == 0) {
						_this.user_quizzes.splice(item.pkid, 1);
					}
					_this.notificationsGet();
				})
				.catch(function (e) {
					console.log('Error: setQuizResultStatus:' + e);
				});
		},

		userQuizzesLoad() {
			let _this = this;

			_this.user_quizzes = [];
			_this.totalRows = 0;

			let params = new URLSearchParams();
			params.append('token', this.$store.state.session_id);

			axios({
				url: _this.$store.state.api_url + 'bio_testing_quizzes_load',
				params: params,
			})
				.then(function (response) {
					if (response.data.status == 1) {
						_this.user_quizzes = Object.values(response.data.data);
						_this.totalRows = _this.user_quizzes.length;
					} else if (response.data.status == -1) {
						_this.user_quizzes = [];
						_this.totalRows = 0;
					}
					_this.isBusy = false;
				})
				.catch(function () {});
		},
	},
	computed: {
		sortOptions() {
			return this.fields
				.filter((f) => f.sortable)
				.map((f) => {
					return { text: f.label, value: f.key };
				});
		},
	},
	created() {},
	mounted() {
		this.userQuizzesLoad();
	},
	watch: {},
};
</script>
